// extracted by mini-css-extract-plugin
export var locationBadge = "locations-module--location-badge--c52c9";
export var locationCard = "locations-module--location-card--6e053";
export var locationCardExcerpt = "locations-module--location-card-excerpt--3350c";
export var locationCardImage = "locations-module--location-card-image--d135e";
export var locationCardInfo = "locations-module--location-card-info--8c29f";
export var locationCardText = "locations-module--location-card-text--0b7ee";
export var locationInfo = "locations-module--location-info--6f435";
export var locationLink = "locations-module--location-link--b4cb0";
export var locationPlaceholder = "locations-module--location-placeholder--4bcbb";
export var locationsWrap = "locations-module--locations-wrap--e99f3";
export var similarLocationCard = "locations-module--similar-location-card--5018d";
export var similarLocationCardText = "locations-module--similar-location-card-text--d0401";